import React from 'react';
import { MarkdownText } from 'components';


const QAComponent = ({ /*type = '',*/ item, disabled, loading, onQuestionSet }) => {
	const { show, text }  = item;
	
	if (!text) { return null; }
	
	let aParsed = loading ? null : text;
	let btnComponent = null;
	let btns = null;
  
	// Extract question(s) from ai response
	if (aParsed) {
		let nextTitle = '您的下一個問題是：'; // Default title

		if (!aParsed.includes(nextTitle)) {
			nextTitle = '另外三個參考問題：';
		}

		aParsed = aParsed.replace(/~~/g, '');
		aParsed = aParsed.split(nextTitle);

		if (aParsed.length > 1 && !disabled) {
			btns = [];

			const num = nextTitle.includes('一個') ? 1 : 3; // Number of questions

			let txtQuestions = aParsed[1];
			let idx = txtQuestions.indexOf('？') + 1;
			let nextQuestions = [];

			for (let i = 0; i < num; i++) {
				const nextQuestion = txtQuestions.slice(0, idx);

				nextQuestions.push(nextQuestion);

				txtQuestions = txtQuestions.slice(idx);
				idx = txtQuestions.indexOf('？') + 1;
			}

			btns = nextQuestions.map((nextQuestion, i) => (
				<span
					role="button"
					className={`question-submit ua-txt-btn ${
						num > 1 ? 'w-100' : ''
					} txt-semibold`}
					disabled={loading}
					data-actual={nextQuestion}
					data-show={nextQuestion}
					onClick={onQuestionSet}
					key={i}
				>
					{nextQuestion}
				</span>
			));

			btnComponent = (
				<div
					className={`btn-container ${
						num > 1 ? 'multi-question' : 'd-flex align-items-center'
					}`}
				>
					<span className="next-question-title margin-left-auto">
						{nextTitle}
					</span>

					{btns}
				</div>
			);
		}
	}

	return (
		<div className="inputs">
			<div className="txt-orange">
				<span>Q: </span>

				<strong>{show}</strong>
			</div>

			{aParsed && (
				<div className="margin-top-5 margin-bottom-15">
					<MarkdownText children={aParsed[0]} />

					{btnComponent}
				</div>
			)}
		</div>
	);
};

export { QAComponent };
